export default __webpack_public_path__ + "static/media/alamo-arte-7.00296072.webp";